module.exports = __webpack_public_path__ + "img/defaultBg.fc290202.png";